export default __webpack_public_path__ + "static/media/icon-divider.c9a339cf.svg";